import {log} from '../../api/logger';

// Only allow PAR to be logged once.
let loggedPar = false;

/* globals ha */
function logPrimaryActionRendered() {
    if (loggedPar) {
        return;
    }
    loggedPar = true;

    // Pull out basic PAR and send it to the logger.
    ha.userTiming.mark('primary.action.rendered');
    const loadTimeAnalytics = ha.userTiming.getEntriesByName('primary.action.rendered');
    const primaryActionRendered = Math.ceil(
        loadTimeAnalytics.length ? loadTimeAnalytics[0].startTime : 0
    );
    const clientAppversion =
        (window && window.analyticsdatalayer && window.analyticsdatalayer.appversion) || '';

    log({
        clientAppversion,
        primaryActionRendered: `${primaryActionRendered}`
    });
}

export default logPrimaryActionRendered;
export {logPrimaryActionRendered};
